import axios from "axios";

const ServerUrl = process.env.NEXT_PUBLIC_SERVER_URL;

// --------------------------
// AXIOS INSTANCE
// --------------------------
const api = axios.create({
  baseURL: ServerUrl,
});

// ====================================================
// 1️⃣ GET ALL EVENTS (pagination + category + search)
// ====================================================
// export const GetAllEvents = async (
//   category = "All Events",
//   page = 1,
//   pageSize = 6,
//   searchQuery = ""
// ) => {
//   try {
//     let query = `?populate=*`;
//     query += `&pagination[page]=${page}`;
//     query += `&pagination[pageSize]=${pageSize}`;

//     // ⭐ CATEGORY FILTER
//     if (category && category !== "All Events") {
//       query += `&filters[event_category][titel][$eq]=${encodeURIComponent(
//         category
//       )}`;
//     }

//     // ⭐ SEARCH FILTER
//     if (searchQuery) {
//       query += `&filters[titel][$containsi]=${encodeURIComponent(searchQuery)}`;
//     }

//     // ⭐ SORTING
//     query += `&sort=publish_date:desc`;

//     // API CALL
//     const res = await api.get(`/event-details${query}`);
//     return res.data;
//   } catch (err) {
//     console.error("Events Fetch Error:", err.response?.data || err);
//     return null;
//   }
// };





export const GetAllEvents = async (
        activeCategory,
        currentPage,
        pageSize=20
) => {
  try {
    let query = `?populate=*`;
    query += `&pagination[page]=${currentPage}`;
    query += `&pagination[pageSize]=${pageSize}`;
    query += `&sort=publish_date:desc`;

    // CATEGORY FILTER
    if (activeCategory && activeCategory !== "All Events") {
      query += `&filters[event_category][titel][$eq]=${encodeURIComponent(
        activeCategory
      )}`;
    }

    // API CALL
    const res = await api.get(`/event-details${query}`);
    return res.data;
  } catch (err) {
    console.error("Events Fetch Error:", err.response?.data || err);
    return null;
  }
};

// ====================================================
// 2️⃣ GET EVENT BY SLUG
// ====================================================
export const GetEventBySlug = async (slug) => {
  try {
    if (!slug) return null;

    const query = `?filters[slug][$eq]=${encodeURIComponent(slug)}&populate=*`;

    const res = await api.get(`/event-details${query}`);
    return res.data;
  } catch (err) {
    console.error("Fetch Event By Slug Error:", err.response?.data || err);
    return null;
  }
};
// ====================================================
// 3️⃣ GET ALL EVENT CATEGORIES
// ====================================================
export const getEventCategories = async () => {
  try {
    const res = await api.get(`/event-categories?sort=titel:asc`);
    return res.data;
  } catch (err) {
    console.error("Category Fetch Error:", err);
    return null;
  }
};



export const getEventMain = async () => {
  try {
    const res = await api.get(`/event?populate[multiple_image_for_banner][populate]=image`);
    return res.data;
  } catch (err) {
    console.error("Category Fetch Error:", err);
    return null;
  }
};